import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'

import { useI18n } from '@popety_io/popety-io-lib'
import { estimateSelector } from '../../redux'

const Notes = () => {
  const estimate = useSelector(estimateSelector)

  const { t } = useI18n()

  return (
    <Box
      sx={{
        marginTop: '20px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
            color: (theme) => theme.palette.secondary.main,
          }}
          // fontWeight={600}
        >
          {t('estimate.commentaire')}
        </Typography>
      </Box>
      {estimate?.notes?.map((note: any, i: number) => (
        <Box>
          <Typography
            key={i}
            variant="h6"
            sx={{
              fontWeight: 400,
              fontSize: '1rem',
              wordBreak: 'break-word',
              whiteSpace: 'break-spaces',
              width: '100%',
              '& img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              },
              paddingBottom: '10px',
              paddingTop: '10px',
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: note?.content || '' }} />
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default Notes
